<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="primary" size="small" @click="openAddForm"  icon="el-icon-plus" plain>添加</el-button>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>

                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                            prop="Id"
                            label="Id">
                        </el-table-column>
                        <el-table-column
                            prop="QQ"
                            label="QQ群号">
                        </el-table-column>
                        <el-table-column
                            prop="Name"
                            label="QQ群名称">
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="300px">
                            <template slot-scope="scope">
                                <el-button type="success" plain @click="openUpdateForm(scope.row)">编辑</el-button>
                                  <el-button type="danger" plain @click="del(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog :title="formTitle" :visible.sync="dialogFormVisible" width="400px">
            <el-form :model="newModel"  :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="qq群号" prop="QQ">
                    <el-input placeholder="请输入qq群号" v-model="newModel.QQ"></el-input>
                </el-form-item>
                <el-form-item label="qq群名称" prop="Name">
                    <el-input placeholder="请输入qq群名称" v-model="newModel.Name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getQQGroup, addQQGroup,delQQGroup,updateQQGroup } from '@/api/qqGroup'
import { constantRoutes } from "@/router"
export default {
    data(){
        return {
            dialogFormVisible:false,
            formTitle:"",
            total:0,
            formId:null,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                pSize:20,
                pIndex:1,
            },newModel:{
                Name:"",
                QQ:"",
            },
            rules: {
                Name: [
                    { required: true, message: '请填写QQ群名称', trigger: 'blur' },
                    { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                ],
                QQ: [
                    { required: true, message: '请填写QQ群号', trigger: 'blur' }
                ]
            },
            tableData:[]
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
        this.menus = constantRoutes[0].children.filter(item => {
            return item.meta.showInMenu == true
        })
    },
    methods: {
        openUpdateForm(info) {
            this.newModel.QQ = info.QQ
            this.newModel.Name = info.Name
            this.formTitle = '编辑'
            this.dialogFormVisible = true
            this.formId = info.Id
        },
        submitForm() {
            if(this.formTitle == '新增')
                this.add()
            else
                this.update()
        },
        add(){
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    addQQGroup(this.newModel)
                    .then(() => {
                    this.$message({
                        message: "新增成功！",
                        type: 'success'
                    });
                    this.query()
                    this.dialogFormVisible = false
                    })
                    .catch(err => {
                        console.log(err)
                    })
                } else {
                    return false;
                }
            });
        },
        update(){
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    updateQQGroup(this.formId,this.newModel)
                    .then(() => {
                    this.$message({
                        message: "修改成功！",
                        type: 'success'
                    });
                    this.query()
                    this.dialogFormVisible = false
                    })
                    .catch(err => {
                        console.log(err)
                    })
                } else {
                    return false;
                }
            });
        },
        del(scope){
            this.$confirm('确认删除该群组吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                delQQGroup(scope.Id)
                    .then(() => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.tableData.forEach((item, index, arr)=>{
                            if(item==scope){
                                arr.splice(index, 1);
                            }
                        });
                    })
                    .catch(err => {
                        console.log(err)
                    })
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        query(){
            this.isLoading=true;
            
            getQQGroup(this.queryModel).then(res => {
                this.tableData=res.data.Result
                this.total=res.data.TotalCount
                this.isLoading = false
                })
            .catch(err => {
                console.log(err)
                this.isLoading = false
            });
        },
        openAddForm(){
            this.newModel={
                Name:"",
                QQ:""
            };
            this.formTitle = '新增';
            this.dialogFormVisible=true;

        },
        reset(){
            this.queryModel={
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>